import ContactAdditionalAPI from '@/api/ContactAdditionalAPI.js';
import httpClient from '@/api/axios-httpclient';
import { isNullOrEmpty } from '../../common/objectUtil';

export default {
	getAllContactAdditional: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: ContactAdditionalAPI.getAPIUrl() + '/getcontactpaging',
			data: payload
		});

		if (res.Success) {
			context.commit('updateContactAdditionalList', res.Data);
		}

		// Trả kết quả
		return res;
	},

	// thực hiện xóa thông tin liên hệ bổ sung
	deleteContactAdditional: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: ContactAdditionalAPI.getAPIUrl() + '/deleteContact',
			params: payload
		});

		if (res.Success) {
			// context.commit('updateDeleteContact', res);
		}

		// Trả kết quả
		return res;
	},
	// thực hiện thêm thông tin liên hệ bổ sung
	addContactAdditional: async function(context, payload) {
		//Hiển thị loading khi ở màn thêm email liên hệ
		let isLoading = false;
		if (!isNullOrEmpty(payload.isLoading)) {
			isLoading = payload.isLoading;
		}

		let res = await httpClient.postAsync(
			{
				url: ContactAdditionalAPI.getAPIUrl() + '/addContact',
				data: payload
			},
			isLoading,
			false
		);

		return res;
	},

	// thực hiện sửa thông tin liên hệ bổ sung
	updateContactAdditional: async function(context, payload) {
		//Hiển thị loading khi ở màn sửa email liên hệ
		let isLoading = false;
		if (!isNullOrEmpty(payload.isLoading)) {
			isLoading = payload.isLoading;
		}

		let res = await httpClient.postAsync(
			{
				url: ContactAdditionalAPI.getAPIUrl() + '/updateContact',
				data: payload
			},
			isLoading,
			false
		);

		return res;
	}
};
